import type { ComponentType } from "react";

import type { WidgetProps } from "./widgets/kit";
import * as W from "./widgets/workforce";
import * as M from "./widgets/modules";

/**
 * widget id -> the component that renders it. The ids are the backend
 * catalog's (internal/domain/dashboard_layout.go), which decides what exists,
 * which sizes it takes and who may see it; this table only says how each is
 * drawn. A catalog id with no entry here is skipped by the dashboard rather
 * than shown broken, so the backend can ship a widget before the frontend
 * does without anything on screen changing.
 */
export const WIDGET_COMPONENTS: Record<string, ComponentType<WidgetProps>> = {
  "employees.total": W.TotalEmployeesWidget,
  "employees.new_joiners": W.NewJoinersWidget,
  "employees.status": W.EmployeeStatusWidget,
  "employees.hiring_trend": W.HiringTrendWidget,
  "employees.by_department": W.DepartmentsWidget,
  "employees.by_branch": W.BranchesWidget,
  "employees.directory": W.EmployeeDirectoryWidget,
  "workforce.insights": W.WorkforceInsightsWidget,
  "workforce.pulse": W.WorkforcePulseWidget,

  "attendance.present_month": W.PresentMonthWidget,
  "attendance.mix": W.AttendanceMixWidget,
  "attendance.overtime": W.OvertimeWidget,
  "attendance.today_present": W.TodayPresentWidget,
  "attendance.today_absent": W.TodayAbsentWidget,
  "attendance.today_late": W.TodayLateWidget,
  "attendance.today_not_marked": W.TodayNotMarkedWidget,
  "attendance.today_roster": W.TodayRosterWidget,
  "geofencing.snapshot": W.GeoFencingWidget,

  "leaves.pending": W.PendingLeavesWidget,
  "leaves.on_leave_today": W.OnLeaveTodayWidget,
  "leaves.recent": W.RecentLeavesWidget,

  "exit.summary": M.ExitSummaryWidget,
  "exit.notice_period": M.NoticePeriodWidget,
  "exit.pending_clearance": M.PendingClearanceWidget,

  "probation.summary": M.ProbationSummaryWidget,
  "probation.on_probation": M.OnProbationWidget,
  "probation.ending_soon": M.ProbationEndingWidget,

  "payroll.total": W.PayrollTotalWidget,
  "payroll.status": W.PayrollStatusWidget,

  "recruitment.summary": M.RecruitmentSummaryWidget,
  "recruitment.funnel": M.RecruitmentFunnelWidget,
  "recruitment.open_positions": M.OpenPositionsWidget,

  "performance.summary": M.PerformanceSummaryWidget,

  "actions.center": M.ActionCenterWidget,
  "helpdesk.open_tickets": W.TicketsWidget,

  "events.upcoming": M.UpcomingEventsWidget,
  "activity.recent": W.RecentActivityWidget,

  "documents.summary": M.DocumentsSummaryWidget,
  "documents.pending_verification": M.PendingVerificationWidget,
  "compliance.summary": M.ComplianceSummaryWidget,

  "assets.summary": M.AssetsSummaryWidget,
  "expenses.total": W.ExpenseTotalWidget,
  "expenses.summary": W.ExpenseSummaryWidget,
};
